<template>
    <div></div>
</template>

<script>

export default {
    name: 'BuildSimulatorUrl',

    methods: {
        async buildSimulatorUrl(propertyId, companyId) {
            const accessToken = localStorage.getItem('access_token');

            if (!['PublicLot', 'indexAreaPublica'].includes(this.$route.name) && accessToken)
                return `${process.env.VUE_APP_SIMULATOR_HOST}/${companyId}/${propertyId}?accessToken=${accessToken}`;

            return `${process.env.VUE_APP_SIMULATOR_HOST}/${companyId}/${propertyId}`;
        },
    },
};

</script>
